import React from "react";
import { Grid, Typography } from "@mui/material";

export default function ProductImageField({ errors, touched, setFieldValue }) {
  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
        תמונה
      </Typography>

      <input
        id="image"
        name="image"
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.currentTarget.files?.[0] || null;
          setFieldValue("image", file);
        }}
      />

      {touched.image && errors.image && (
        <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{errors.image}</div>
      )}
    </Grid>
  );
}
